/**
 * Safe GA4 event tracking utility.
 * Guards against gtag being unavailable (ad blocker, cookie banner, SSR).
 * Never throws – analytics must never interrupt the app flow.
 */
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    // silently ignore
  }
};
